import { useEffect, useState } from "react";
import {
  COARSE_POINTER_MEDIA_QUERY,
  getIsMobileDevice,
} from "../utilities/device-detection";

export function useIsMobileDevice(): boolean {
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  /**
   * Browser-only state. First render false so SSR/tests no touch window too
   * early. Effect runs, reads real device input, then updates mount gate.
   */
  useEffect(() => {
    const coarsePointer = window.matchMedia(COARSE_POINTER_MEDIA_QUERY);
    const updateIsMobileDevice = () => {
      setIsMobileDevice(getIsMobileDevice());
    };

    // Set initial truth after mount, then listen for pointer mode changes.
    updateIsMobileDevice();
    coarsePointer.addEventListener("change", updateIsMobileDevice);

    return () => {
      coarsePointer.removeEventListener("change", updateIsMobileDevice);
    };
  }, []);

  return isMobileDevice;
}
